import React from 'react';
import Info from '../Info';
import BackOfficeLayout from '../../components/backoffice/BackOfficeLayout';

export default function BackOfficeInfo() {
  return <Info LayoutComponent={BackOfficeLayout} />;
}
